import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_subtitle, img_title } from '../../../utils/ImagesManagementUtils';

//= ========================================================================

const PanelHeadline = ({
  text, isSubheading, marginBottom = 0,
}) => {
  const myStyles = {
    container: {
      marginTop: 30,
      borderRadius: 4,
      flexDirection: 'row',
      alignSelf: 'flex-start',
      backgroundColor: '#f7fafc',
      padding: 4,
      alignItems: 'center',
      marginBottom,
    },
    containerSubheading: {
      borderRadius: 4,
      flexDirection: 'row',
      marginStart: 9,
      marginTop: 10,
      alignItems: 'center',
    },
    image: {
      width: isSubheading ? 16 : 24, height: isSubheading ? 14 : 24,
    },
    text: {
      marginStart: 5,
      marginEnd: 5,
      fontFamily: 'Quicksand-SemiBold',
      fontSize: isSubheading ? 18 : 24,
      color: '#008cff',
    },
  };

  return (
    <View
      style={isSubheading ? myStyles.containerSubheading : myStyles.container}
    >
      <Image
        fadeDuration={0}
        style={myStyles.image}
        source={isSubheading ? img_subtitle : img_title}
      />
      <Text style={myStyles.text}>
        {text}
      </Text>
    </View>

  );
};
export default PanelHeadline;
